import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-switch_close",
  "use": "icon-switch_close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-switch_close\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M14.91,7H9.09a5,5,0,1,0,0,10h5.82a5,5,0,1,0,0-10ZM9,14.5A2.5,2.5,0,1,1,11.5,12,2.5,2.5,0,0,1,9,14.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol